module.exports = __webpack_public_path__ + "img/1562386161.d9715eee.jpg";